module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_02视频位置.jpg?v=bd220f06";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_02视频位置.jpg
 ** module id = 59
 ** module chunks = 1 2
 **/